module.exports = __webpack_public_path__ + "static/img/WechatIMG38.e24750e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatIMG38.png
// module id = R6QE
// module chunks = 1